import React from 'react'
import styled from 'styled-components'
import Soji from './Draft pics/Soji.jpg'
import Awajis from './Draft pics/Awajis.jpg'

function draft() {
  return (
    <div>
        <Contain>
            <Imagine src={Soji}></Imagine>
            <Imagine src={Awajis}></Imagine>
            <Imagine src={Soji}></Imagine>
            <Imagine src={Soji}></Imagine>
            <Imagine src={Soji}></Imagine>
            <Imagine src={Soji}></Imagine> 
        </Contain>
    </div>
  )
}

export default draft

const Contain = styled.div`
width: 100%;
`

const Imagine = styled.img`
height: 300px;
width: 300px;
`